import axios from 'axios';

const ScheduleService = {
  getChannels() {
    const url = `${process.env.REACT_APP_HOST_URL}Channel/GetChannelLookup`;
    return axios.get(url);
  },

  getSchedules(querystring) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetGeneratedScores${querystring}`;
    return axios.get(url);
  },

  getScheduleDetails(scheduleId, channeId, month, year) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetGeneratedScheduleDetails/${scheduleId}?ChannelId=${channeId}&Month=${month}&Year=${year}`;
    return axios.get(url);
  },

  getChannelScoring(channelId) {
    const url = `${process.env.REACT_APP_HOST_URL}Channel/GetChannelScoring/${channelId}`;
    return axios.get(url);
  },

  generateSchedules(params) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/TriggerGenerateSchedule/`;
    return axios.post(url, params);
  },

  submitSchedule(params) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/SubmitSchedule/`;
    return axios.post(url, params);
  },

  exportSubmissions(parameters) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/ExportSchedule${parameters}`;
    return axios.get(url, { responseType: 'arraybuffer' });
  },

  getScheduleSession() {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetScheduleSession`;
    return axios.get(url);
  },

  saveScheduleSession(json) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/AddScheduleSession${json}`;
    return axios.post(url, json);
  },

  exportStatistics(parameters) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/ExportStatistics${parameters}`;
    return axios.get(url, { responseType: 'arraybuffer' });
  },

  getCalendarDetails(scheduleId, channeId, isAdvanced) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetCalendarDetails/${scheduleId}?ChannelId=${channeId}&IsAdvanced=${isAdvanced}`;
    return axios.get(url);
  },

  getSchedulePrograms(channelId, period, titleId, seasonId) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetSchedulePrograms?channelId=${channelId}&start=${period.start}&end=${period.end}&titleId=${titleId}&seasonId=${seasonId}`;
    return axios.get(url);
  },

  getTitleByID(id, channelId) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetTitleDetails?titleId=${id}&channelId=${channelId}`;
    return axios.get(url);
  },

  saveSchedule(json) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/SaveSchedule`;
    return axios.post(url, json);
  },

  updateSchedule(json) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/UpdateSchedule`;
    return axios.put(url, json);
  },
  getTitleGroups() {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetTitleGroups`;
    return axios.get(url);
  },
  getTitleGroupPrograms(querystring, period, channelID) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetTitleGroupPrograms${querystring}&channelId=${channelID}&start=${period.start}&end=${period.end}`;
    return axios.get(url);
  },
  uploadScheduleFile(
    formData,
    period,
    filter,
    overwrite,
    draftScheduleParentId,
    isAdvanced,
    page,
  ) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/ImportSchedule?channelID=${filter.channelId}&start=${period.start}&end=${period.end}&overwrite=${overwrite}&draftScheduleParentId=${draftScheduleParentId}&isAdvanced=${isAdvanced}&page=${page}`;
    return axios.post(url, formData);
  },
  deleteSchedule(json) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/DeleteSchedule`;
    return axios.post(url, json);
  },
  saveUserSession(json) {
    const url = `${process.env.REACT_APP_HOST_URL}User/SaveUserSessionCommand`;
    return axios.post(url, json);
  },
  getUserSession() {
    const url = `${process.env.REACT_APP_HOST_URL}User/GetUserSessionCommand`;
    return axios.get(url);
  },

  getScheduleIDCommand(json) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetScheduleIDCommand`;
    return axios.post(url, json);
  },

  getRestrictedCertificates(id) {
    const url = `${process.env.REACT_APP_HOST_URL}Schedule/GetRestrictedCertificates/${id}`;
    return axios.get(url);
  },
};

export default ScheduleService;
